import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Alert } from 'react-bootstrap';
import AppPage from '../../../AppPages';
import queryString from 'query-string';
import { NavLink } from 'react-router-dom';


class ResetPassword extends Component {

    static contextTypes = { api: PropTypes.object };

    constructor(props) {
        super(props);

        this.onFormChange = this.onFormChange.bind(this);
        this.changePassword = this.changePassword.bind(this);

        this.state = {
            hash: queryString.parse(props.location.search).h
        };

    }

    onFormChange = ({ target }) => {
        this.setState({ [target.name]: target.value });
    };

    changePassword = (e) => {
        e.preventDefault();

        const { pass1, pass2 } = this.state;

        if (!pass1 || !pass2)
            return;

        this.context.api.users.changePassword(this.state.hash, this.state.pass1)
            .then(() => {
                this.setState({ success: true, error: false });
            })
            .catch(() => {
                this.setState({ error: true });
            })
    };

    render() {
        //console.log(this.state.success);
        return (

            <AppPage>

                <div className="row">

                    <div className="col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">

                        <form onChange={this.onFormChange} onSubmit={this.changePassword}>
                            <div className="card">

                                <div className="card-header">
                                    <h3 className="card-title">Cambio de contraseña</h3>
                                </div>
                                {!this.state.success ?
                                    <div className="card-content">

                                        {!this.state.hash ?
                                            <Alert bsStyle='danger'>
                                                El código de regeneración de contraseña no encontrado.
                                            </Alert> : null}

                                        {this.state.error ?
                                            <Alert bsStyle='danger'>
                                                Hubo un error al cambiar la contraseña. Inténtalo más tarde o contacta al soporte técnico.
                                            </Alert> : null}

                                        <div className="form-group">
                                            <label>Contraseña nueva</label>
                                            <input
                                                type="password"
                                                placeholder="Escribe tu contraseña"
                                                className="form-control input-no-border"
                                                name='pass1'
                                                required
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Repite tu contraseña</label>
                                            <input
                                                type="password"
                                                placeholder="Otra vez por favor"
                                                className="form-control input-no-border"
                                                name='pass2'
                                                required
                                            />
                                        </div>
                                    </div> :
                                    <div className="card-content">
                                        <p> <strong className='text-success'>¡Éxito!</strong> Hemos cambiado tu contraseña. <br />
                                            Puedes iniciar sesión en la <NavLink to={'/login'}>página de login</NavLink>.
                                        </p>
                                    </div>}

                                {!this.state.success ?
                                    <div className="card-footer text-center">
                                        <button
                                            type="submit"
                                            className="btn btn-fill btn-wd"
                                        >
                                            Cambiar
                                    </button>
                                    </div> : null}

                            </div>
                        </form>
                    </div>

                </div>

            </AppPage>

        );
    }
}

const mapStateToProps = ({ api: { loggedIn, loading } }) => {
    return {
        loggedIn,
        loading
    };
};

export default connect(mapStateToProps)(ResetPassword);



// WEBPACK FOOTER //
// ./src/App/scenes/AppPages/scenes/ResetPassword/index.js